import 'vuetify/dist/vuetify.min.css';
import 'babel-polyfill';
import cssVars from 'css-vars-ponyfill';

import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuetify from 'vuetify';
import Vuex from 'vuex';
import Axios from 'axios';
import IdleVue from 'idle-vue';
import VueTimers from 'vue-timers';
import VeeValidate from 'vee-validate';

import App from './App.vue';
import router from './routes';
import store from './store';

const eventsHub = new Vue();


Vue.prototype.$http = Axios;
Vue.config.productionTip = false;
Vue.use(Vuetify);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueTimers);
Vue.use(VeeValidate);
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 1800000, // 30 minutes
});
cssVars();

new Vue({ render: h => h(App), router, store }).$mount('#app');
